import { ReactElement } from "react";
import { IWeatherData } from "../../../../../services/http/weatherdata/models/IWeatherData";
import { className } from "../../../../../shared/helpers";
import styles from '../Weather.module.scss';

interface CurrentProps
{
    weatherData: IWeatherData;
    location: string;
}

const Current = (props: CurrentProps): ReactElement =>
{
    return (
        <div className={styles.current}>
            <div {...className(styles.range, "highlighted")}>
                <span className={styles.minimum}>{props.weatherData.minTemperature.toFixed(0)}ºF</span>
                <span className={styles.maximum}>{props.weatherData.maxTemperature.toFixed(0)}ºF</span>
            </div>
            <div className={styles.description}>{props.weatherData.conditionDescription}</div>
            <div {...className(styles.location, "highlighted")}>{props.location}</div>
        </div>
    );
}

export default Current;